// Polyfills
import 'intersection-observer';
import 'weakmap-polyfill';
import 'core-js/features/string/pad-start';

import React from 'react';
import {Provider} from 'react-redux';
import {applyMiddleware, compose, createStore} from 'redux';
import {createEpicMiddleware, EpicMiddleware} from 'redux-observable';
import * as Sentry from '@sentry/react';
import {BrowserRouter} from 'react-router-dom';

import {rootEpic} from './epics/Epics';
import {rootReducer} from './reducers/Reducers';

import {IAction} from './actions/Actions';
import {startup} from './actions/startup/StartupActions';
import {defaultAppState, IAppState} from './state/AppState';
import Application from './components/Application';
import './App.scss';

const epicMiddleware: EpicMiddleware<
  IAction<any>,
  IAction<any>,
  IAppState,
  any
> = createEpicMiddleware();

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  defaultAppState(),
  composeEnhancers(applyMiddleware(epicMiddleware)),
);

epicMiddleware.run(rootEpic);

store.dispatch(startup());

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <Sentry.ErrorBoundary>
        <BrowserRouter>
          <Application />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </Provider>
  );
};

export default App;
